import ApiServiceV6 from '@/helpers/api.service.v6lite';

const APIV6 = new ApiServiceV6();

const ENDPOINT = '/transaction-monitoring';

export const state = {
  errors: null
}

export const mutations = {
  SET_ERROR(state, errors) {
    state.errors = errors;
  }
}

export const actions = {
  // NOTE: the page currently runs on mock data (frontend preview). This action is the
  // placeholder for backend wiring: it POSTs to /transaction-monitoring/{action}, mirroring
  // the existing walletFreezing module.
  actionTransactionMonitoring(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`${ENDPOINT}/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response?.data?.errors);
          reject(response?.data?.errors);
        });
    });
  }
}

export const getters = {}
